module.exports = require("xml");


//////////////////
// WEBPACK FOOTER
// external "xml"
// module id = 478
// module chunks = 0